import { render } from "./DBlog.vue?vue&type=template&id=13f9266a"
import script from "./DBlog.vue?vue&type=script&lang=js"
export * from "./DBlog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__